import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";

import { useQueryClient } from "@tanstack/react-query";
import { Col, Modal, Row, Spin, Typography } from "antd";
import _ from "lodash";
import { withProcedureWraper } from "../..";
import { getEnv } from "../../../../AppConfigs";
import { Routes } from "../../../../AppRoutes";
import { Box } from "../../../../components/box";
import BoxSectionItem from "../../../../components/box-section/box-section-item";
import { Icon } from "../../../../components/icon";
import { InputArrayData } from "../../../../components/input";
import DownloadPassport from "../../../../components/input/arrayData/DownloadPassport";
import { UserSelect } from "../../../../components/input/select/UserSelect";
import ModalNotification from "../../../../components/modal-notification";
import { CreateNotification } from "../../../../components/notifier";
import { Environment } from "../../../../constants";
import { approverType } from "../../../../constants/itCodeRequestConstants";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../../constants/statusConstants";
import { getDDMMYYYFormat, getHHmmFormat, getUCTDate } from "../../../../helper/dateTimeHelper";
import { getAppEnv } from "../../../../helper/util";
import { useUser } from "../../../../hook";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { Message } from "../../../../modules/message";
import { BusinessTicketRequestService } from "../../../../services/company-office/BusinessTicketService";
import { MailService } from "../../../../services/mail/mail.service";
import { useSelector } from "../../../../store/store";
import { PinLayout } from "../../components/layout/PinsLayout";
import CommentSection from "../../info-technology-process/commentsection/comment-sections";
import { ProcessContextProvider, ProcessContextType } from "../../process-context";
import { FileAttachmentCard } from "../../upload";
import { eApprovalChangeOptions } from "../companyRequestContants/companyRequestContants";
import ApprovalProcess, { ApprovalProcessApprover, ApprovalProcessHistory } from "./components/approval-process";
import { PassportContentForm, PassportContentStructure } from "./formBusinessTicket";
import useHrProfile from "./hooks/use-hr-profile";

const { Text } = Typography;

const siteUrl = getEnv("REACT_APP_APPROVER_BUSINESS_TICKET_REQUEST_URL");

export const businessTicketDetail: FC = withProcedureWraper(() => {
  const user = useSelector((state) => state.user);
  const userData = useUser();
  const currentUserName = user?.current?.username;

  const { pathname } = useLocation();
  const isMinePage = pathname.includes("my-details");

  const history = useHistory();
  const [officialBusinessTicketRequest, setOfficialBusinessTicketRequest] = useState(null as any);
  const [fileContent, setFileContent] = useState<any>([]);
  const { id } = useRouteMatch().params as any;
  const [comment, setComment] = useState("" as string);
  const [approvalType, setApprovalType] = useState(0);
  const [approvalStep, setApprovalStep] = useState(approverType.approver);
  const [pickedItHead, setPickedItHead] = useState(null as any);
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState<string>("");
  const [notificationTitle, setNotificationTitle] = useState<string>("Thông báo");
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  // const userExport = [
  //   "canbo1@viags.vn",
  //   "botit@viags.vn",
  //   "canbo2@viags.vn",
  //   "thiennv@viags.vn",
  //   "huongptt@viags.vn",
  //   "huongdtt@viags.vn",
  //   "anhttt@viags.vn",
  //   "hieptd@viags.vn",
  // ];
  const queryClient = useQueryClient();

  const { data: hrProfile, isLoading: isLoadingHrProfile } = useHrProfile({
    email: userData?.email,
  });

  const ticketType = officialBusinessTicketRequest?.fields?.eTicketType;
  const isRefund = ticketType === "refund";

  const eRequestStatus = officialBusinessTicketRequest?.fields?.eRequestStatus;
  const isDraft = eRequestStatus === requestStatus.draft;

  const isMine = currentUserName.toLowerCase() === officialBusinessTicketRequest?.createdBy?.user?.email?.toLowerCase();

  const isFinished = [
    requestStatus.completed,
    requestStatus.rejected,
    requestStatus.canceled,
    requestStatus.revoked,
  ].includes(eRequestStatus);

  const { getInputProps } = useForm({
    structure: [
      {
        name: "passport2",
        label: "Giấy đi đường",
        defaultValue: [],
      },
    ],
    onSubmit: () => {},
  });

  const [passport, setPassport] = useState<any>(
    getInputProps("passport2").value.length !== 0 ? getInputProps("passport2").value : [],
  );

  const sendMail = async (status: string, rejectComment?: any) => {
    if (getAppEnv() === Environment.development) {
      return;
    }

    const { fields } = officialBusinessTicketRequest;
    const url = siteUrl + "/details/" + officialBusinessTicketRequest.id;
    let template = mailtemplates.find((m: any) => m.eMailType === "BTRA");
    let content = template.eContent;
    let subject = template.eSubject;
    let arrApprover = fields.eApprovedByITLead.split("|");
    let name = officialBusinessTicketRequest.createdBy.user.displayName;
    let tomail = officialBusinessTicketRequest.createdBy.user.email;
    let doing = "duyệt";
    if (status === requestStatus.rejected) {
      template = mailtemplates.find((m: any) => m.eMailType === "BTRR");
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", rejectComment?.value ? `${rejectComment?.value} (${rejectComment?.date})` : "")
        .replace(mailRegexs.siteUrl, url);
      subject = template.eSubject;

      if (approvalStep === approverType.ithead) {
        tomail = fields.eApprovedByITHead.split("|")[0];
        content = template.eContent
          .replace(mailRegexs.zero + ";", fields.eApprovedByITLead.split("|")[1])
          .replace(mailRegexs.one + ";", rejectComment?.value ? `${rejectComment?.value} (${rejectComment?.date})` : "")
          .replace(mailRegexs.siteUrl, url);
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      if (approvalStep === approverType.assignee) {
        tomail = officialBusinessTicketRequest.createdBy.user.email;
      }
      if (approvalStep === approverType.approver) {
        tomail = officialBusinessTicketRequest.createdBy.user.email;
      }
      if (approvalStep === approverType.itlead) {
        tomail = fields.eApprovedBy.split("|")[0];
        content = template.eContent
          .replace(mailRegexs.zero + ";", fields.eApprovedBy.split("|")[1])
          .replace(mailRegexs.one + ";", rejectComment?.value ? `${rejectComment?.value} (${rejectComment?.date})` : "")
          .replace(mailRegexs.siteUrl, url);
        const message = MailService.buildMailMesssage(subject, content, "html", tomail);
        await MailService.sendMail(message);
        tomail = officialBusinessTicketRequest.createdBy.user.email;
      }
    } else if (approvalStep === approverType.assignee) {
      template = mailtemplates.find((m: any) => m.eMailType === "BTRF");
      tomail = officialBusinessTicketRequest.createdBy.user.email;
      name = officialBusinessTicketRequest.createdBy.user.displayName;
      content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.one, comment || "");
      subject = template.eSubject;
    } else {
      if (approvalType === approverType.approver) {
        arrApprover = fields.eApprovedByITLead.split("|");
      }
      if (approvalType === approverType.itlead) {
        arrApprover = fields.eApprovedByITHead.split("|");
      }
      if (approvalType === approverType.ithead) {
        arrApprover = fields.eAssignee.split("|");
        doing = "thực hiện";
      }
      tomail = arrApprover.length > 0 ? arrApprover[0] : "";
      name = arrApprover.length > 1 ? arrApprover[1] : "";
      content = template.eContent
        .replace(mailRegexs.zero + ";", name)
        .replace(mailRegexs.one + ";", doing)
        .replace(mailRegexs.two + ";", officialBusinessTicketRequest.createdBy.user.displayName)
        .replace(
          mailRegexs.three + ";",
          `${getDDMMYYYFormat(officialBusinessTicketRequest.createdDateTime)} - ${getHHmmFormat(
            officialBusinessTicketRequest.createdDateTime,
          )}`,
        )
        .replace(mailRegexs.siteUrl, url);
      // if (approvalType === approverType.itlead) {
      //   const message = MailService.buildMailMesssage(subject, content, 'html', 'it@viags.vn');
      //   const res = await MailService.sendMail(message);
      // }
    }

    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const handleApproveWithConfirm = () => {
    Modal.confirm({
      title: "Xác nhận đồng ý",
      content: "Anh/chị có chắc chắn muốn đồng ý yêu cầu này?",
      okText: "Xác nhận",
      cancelText: "Bỏ qua",
      onOk: () => approveRequest(),
    });
  };

  const approveRequest = () => {
    const { fields } = officialBusinessTicketRequest;
    const dateApprove = getUCTDate();
    const approveComment = {
      type: "approve",
      value: comment || "",
      date: `${getDDMMYYYFormat(dateApprove)} ${getHHmmFormat(dateApprove)}`,
    };
    switch (approvalType) {
      case approverType.approver:
        const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
        const approverComment = [...arrComment];
        approverComment.push(approveComment);
        fields.eDeptHeadComment = JSON.stringify(approverComment);
        fields.eApprovedStatus = requestStatus.approved;
        fields.eApprovedDate = dateApprove;
        // if (pickedItHead) {
        //   const itLeadTmp = employees.find((f: any) => f.eMail === pickedItHead);
        //   fields.eApprovedByITLead =  `${itLeadTmp.eMail}|${itLeadTmp.Title}`;
        // }
        break;
      case approverType.itlead:
        if (passport.length <= 0) {
          setNotificationTitle("Đồng ý thất bại");
          setNotificationMessage("Vui lòng thêm giấy đi đường");
          setIsNotificationModalOpen(true);
          return;
        }
        const arrITLeadComment = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
        const itLeadComment = [...arrITLeadComment];
        itLeadComment.push(approveComment);
        fields.eITLeadComment = JSON.stringify(itLeadComment);
        fields.eApprovedByITLeadStatus = requestStatus.approved;
        fields.eApprovedByITLeadDate = dateApprove;
        fields.ePassportContent = JSON.stringify(passport);
        if (pickedItHead) {
          fields.eApprovedByITHead = `${pickedItHead.value}|${pickedItHead.label}`;
          const newPassport = passport.map((item: any) => ({
            ...item,
            ITHead: `${pickedItHead.value}|${pickedItHead.label}`,
          }));
          setPassport(newPassport);
          fields.ePassportContent = JSON.stringify(newPassport);
        }
        // if (employeesSelected) {
        //   const assignee = employees.find(
        //     (v: any) =>
        //       v.eMail.toLowerCase() === employeesSelected.toLowerCase()
        //   );
        //   if (assignee) {
        //     fields.eAssignee = `${assignee.eMail}|${assignee.Title}`;
        //   }
        // }
        break;
      case approverType.ithead:
        const arrITHeadComment = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
        const itHeadComment = [...arrITHeadComment];
        itHeadComment.push(approveComment);
        fields.eITHeadComment = JSON.stringify(itHeadComment);
        fields.eApprovedByITHeadStatus = requestStatus.approved;
        fields.eApprovedByITHeadDate = dateApprove;
        fields.eRequestStatus = requestStatus.inProgress;
        break;
      case approverType.assignee:
        const arrAssignedComment = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
        const assignedComment = [...arrAssignedComment];
        assignedComment.push(approveComment);
        fields.eAssigneeComment = JSON.stringify(assignedComment);
        fields.eAssigneeStatus = requestStatus.approved;
        fields.eAssigneeStatusDate = dateApprove;
        fields.eRequestStatus = requestStatus.completed;
        break;
      default:
        break;
    }

    // Cập nhật trạng thái trong eSteps
    if (hrProfile && fields.eSteps) {
      try {
        const currentUserEmail = hrProfile.Email?.toLowerCase() || userData?.email?.toLowerCase();

        if (currentUserEmail) {
          const steps = JSON.parse(fields.eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;
          const stepLength = steps.length;

          if (steps && stepLength > 0) {
            // Tìm step hiện tại và approver hiện tại
            let found = false;
            let isFinal = false;

            for (let stepIndex = 0; stepIndex < stepLength; stepIndex++) {
              const step = steps[stepIndex];
              const isStepCompleted = step.every((approver) => approver.isApproved || approver.isRejected);

              if (!isStepCompleted) {
                for (const approver of step) {
                  const approverEmail = approver.email?.toLowerCase();
                  if (approverEmail === currentUserEmail && !approver.isApproved && !approver.isRejected) {
                    // Cập nhật approver: đánh dấu đã approve và thêm history
                    approver.isApproved = true;
                    approver.isRejected = false;
                    approver.histories = approver.histories || [];
                    approver.histories.push({
                      label: "Đã phê duyệt",
                      status: "approved",
                      updatedDateTime: dateApprove,
                      reason: comment || "",
                    });
                    found = true;
                    if (stepIndex === stepLength - 1) isFinal = true;
                    break;
                  }
                }
                if (found) {
                  break;
                }
              }
            }

            // Cập nhật lại eSteps trong fields
            if (found) {
              fields.eSteps = JSON.stringify(steps);
            }

            if (isFinal) {
              fields.eRequestStatus = requestStatus.completed;
            }
          }
        }
      } catch (error) {
        console.error("Error updating eSteps:", error);
      }
    }

    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Đã duyệt thành công.`,
          icon: "/icons/success.png",
        });
        queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
        sendMail(requestStatus.approved);
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Đã duyệt thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  // const handleRecoverWithConfirm = () => {
  //   Modal.confirm({
  //     title: "Xác nhận thu hồi",
  //     content: "Anh/chị có chắc chắn muốn thu hồi yêu cầu này?",
  //     okText: "Xác nhận",
  //     cancelText: "Bỏ qua",
  //     onOk: () => recoverRequest(),
  //   });
  // };

  // const recoverRequest = () => {
  //   const { fields } = officialBusinessTicketRequest;
  //   switch (approvalType) {
  //     case approverType.approver:
  //       fields.eDeptHeadComment = "";
  //       fields.eApprovedStatus = "";
  //       fields.eApprovedDate = null;
  //       break;
  //     case approverType.itlead:
  //       fields.eDeptHeadComment = "";
  //       fields.eApprovedByITLeadStatus = "";
  //       fields.eApprovedByITLeadDate = null;
  //       break;
  //     case approverType.ithead:
  //       fields.eITHeadComment = "";
  //       fields.eApprovedByITHeadStatus = "";
  //       fields.eApprovedByITHeadDate = null;
  //       fields.eRequestStatus = requestStatus.submitted;
  //       break;
  //     case approverType.assignee:
  //       fields.eAssigneeComment = "";
  //       fields.eAssigneeStatus = "";
  //       fields.eAssigneeStatusDate = null;
  //       fields.eRequestStatus = requestStatus.submitted;
  //       break;
  //     default:
  //       break;
  //   }

  //   // Cập nhật trạng thái trong eSteps
  //   if (hrProfile && fields.eSteps) {
  //     try {
  //       const currentUserEmail = hrProfile.Email?.toLowerCase() || userData?.email?.toLowerCase();

  //       if (currentUserEmail) {
  //         const steps = JSON.parse(fields.eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;
  //         const dateRecover = getUCTDate();

  //         if (steps && steps.length > 0) {
  //           // Tìm step hiện tại chưa có người duyệt
  //           let currentStepIndex = -1;
  //           for (let stepIndex = 0; stepIndex < steps.length; stepIndex++) {
  //             const step = steps[stepIndex];
  //             const hasNoApprover = step.every((approver) => !approver.isApproved && !approver.isRejected);
  //             if (hasNoApprover) {
  //               currentStepIndex = stepIndex;
  //               break;
  //             }
  //           }

  //           // Nếu không tìm thấy step hiện tại chưa có người duyệt, không thể thu hồi
  //           if (currentStepIndex === -1 || currentStepIndex === 0) {
  //             // Không có step nào chưa có người duyệt hoặc là step đầu tiên
  //           } else {
  //             // Tìm step trước đó mà user đã approve
  //             let found = false;
  //             for (let stepIndex = currentStepIndex - 1; stepIndex >= 0; stepIndex--) {
  //               const step = steps[stepIndex];
  //               for (const approver of step) {
  //                 const approverEmail = approver.email?.toLowerCase();
  //                 if (approverEmail === currentUserEmail && (approver.isApproved || approver.isRejected)) {
  //                   // Thu hồi: đặt lại trạng thái về chưa approve/reject
  //                   approver.isApproved = false;
  //                   approver.isRejected = false;
  //                   // Thêm history về việc thu hồi
  //                   approver.histories = approver.histories || [];
  //                   approver.histories.push({
  //                     label: "Đã thu hồi",
  //                     status: "recovered",
  //                     updatedDateTime: dateRecover,
  //                     reason: comment || "",
  //                   });
  //                   found = true;
  //                   break;
  //                 }
  //               }
  //               if (found) {
  //                 break;
  //               }
  //             }

  //             // Cập nhật lại eSteps trong fields
  //             if (found) {
  //               fields.eSteps = JSON.stringify(steps);
  //               fields.eRequestStatus = requestStatus.submitted;
  //             }
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error updating eSteps:", error);
  //     }
  //   }

  //   BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
  //     .then((res) => {
  //       CreateNotification({
  //         title: "Thành công",
  //         body: `Thu hồi thành công.`,
  //         icon: "/icons/success.png",
  //       });
  //       queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
  //       sendMail(requestStatus.approved);
  //       history.push(Routes.procedureCollaborateTicket.path);
  //     })
  //     .catch((err) => {
  //       CreateNotification({
  //         title: "Thất bại",
  //         body: `Thu hồi thất bại.`,
  //         icon: "/icons/error.png",
  //       });
  //     });
  // };

  // const handleRejectWithConfirm = () => {
  //   Modal.confirm({
  //     title: "Xác nhận không đồng ý",
  //     content: "Anh/chị có chắc chắn không đồng ý yêu cầu này?",
  //     okText: "Xác nhận",
  //     cancelText: "Bỏ qua",
  //     onOk: () => rejectRequest(),
  //   });
  // };

  // const rejectRequest = () => {
  //   const { fields } = officialBusinessTicketRequest;
  //   // fields.eRequestStatus = requestStatus.rejected;
  //   const dateReject = getUCTDate();

  //   if (!comment) {
  //     setNotificationTitle("Thông báo");
  //     setNotificationMessage("Anh Chị vui lòng nhập lưu ý khi từ chối phê duyệt vào ô phía trên !");
  //     setIsNotificationModalOpen(true);
  //     return;
  //   }
  //   const rejectComment = {
  //     type: "reject",
  //     value: comment,
  //     date: `${getDDMMYYYFormat(dateReject)} ${getHHmmFormat(dateReject)}`,
  //   };
  //   switch (approvalType) {
  //     case approverType.approver:
  //       const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
  //       const approverComment = [...arrComment];
  //       approverComment.push(rejectComment);
  //       fields.eDeptHeadComment = JSON.stringify(approverComment);
  //       break;
  //     case approverType.itlead:
  //       const arrCommentITLead = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
  //       const approverCommentITLead = [...arrCommentITLead];
  //       approverCommentITLead.push(rejectComment);
  //       fields.eITLeadComment = JSON.stringify(approverCommentITLead);
  //       fields.eApprovedStatus = null;
  //       fields.eApprovedDate = null;
  //       break;
  //     case approverType.ithead:
  //       const arrCommentITHead = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
  //       const approverCommentITHead = [...arrCommentITHead];
  //       approverCommentITHead.push(rejectComment);
  //       fields.eITHeadComment = JSON.stringify(approverCommentITHead);
  //       fields.eApprovedByITLeadStatus = null;
  //       fields.eApprovedByITLeadDate = null;
  //       break;
  //     case approverType.assignee:
  //       const arrCommentAssigned = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
  //       const approverCommentAssigned = [...arrCommentAssigned];
  //       approverCommentAssigned.push(rejectComment);
  //       fields.eAssigneeComment = JSON.stringify(approverCommentAssigned);
  //       fields.eAssigneeStatus = requestStatus.rejected;
  //       fields.eAssigneeStatusDate = dateReject;
  //       fields.eRequestStatus = requestStatus.rejected;
  //       break;
  //     default:
  //       break;
  //   }

  //   // Cập nhật trạng thái trong eSteps
  //   if (hrProfile && fields.eSteps) {
  //     try {
  //       const currentUserEmail = hrProfile.Email?.toLowerCase() || userData?.email?.toLowerCase();

  //       if (currentUserEmail) {
  //         const steps = JSON.parse(fields.eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;
  //         const stepsLength = steps.length;

  //         if (steps && stepsLength > 0) {
  //           // Tìm step hiện tại và approver hiện tại
  //           let found = false;
  //           for (let stepIndex = 0; stepIndex < stepsLength; stepIndex++) {
  //             const step = steps[stepIndex];
  //             const isStepCompleted = step.every((approver) => approver.isApproved || approver.isRejected);

  //             if (!isStepCompleted) {
  //               for (const approver of step) {
  //                 const approverEmail = approver.email?.toLowerCase();
  //                 if (approverEmail === currentUserEmail && !approver.isApproved && !approver.isRejected) {
  //                   // Cập nhật approver: đánh dấu đã reject và thêm history
  //                   approver.isApproved = false;
  //                   if (stepIndex === stepsLength - 1) {
  //                     fields.eRequestStatus = requestStatus.rejected;
  //                     approver.isRejected = true;
  //                   } else approver.isRejected = false;
  //                   approver.histories = approver.histories || [];
  //                   approver.histories.push({
  //                     label: "Đã từ chối",
  //                     status: "rejected",
  //                     updatedDateTime: dateReject,
  //                     reason: comment || "",
  //                   });

  //                   if (stepIndex > 1 && stepIndex < stepsLength - 1) {
  //                     const prevStep = steps[stepIndex - 1];

  //                     for (const approver of prevStep) {
  //                       if (approver.isApproved || approver.isRejected) {
  //                         approver.isApproved = false;
  //                         approver.isRejected = false;
  //                         approver.histories = approver.histories || [];
  //                       }
  //                     }
  //                   }

  //                   found = true;
  //                   break;
  //                 }
  //               }
  //               if (found) {
  //                 break;
  //               }
  //             }
  //           }

  //           // Cập nhật lại eSteps trong fields
  //           if (found) {
  //             fields.eSteps = JSON.stringify(steps);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error updating eSteps:", error);
  //     }
  //   }

  //   BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
  //     .then((res) => {
  //       CreateNotification({
  //         title: "Thành công",
  //         body: `Từ chối thành công.`,
  //         icon: "/icons/success.png",
  //       });
  //       queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
  //       sendMail(requestStatus.rejected, rejectComment);
  //       history.push(Routes.procedureCollaborateTicket.path);
  //     })
  //     .catch((err) => {
  //       CreateNotification({
  //         title: "Thất bại",
  //         body: `Từ chối thất bại.`,
  //         icon: "/icons/error.png",
  //       });
  //     });
  // };

  const handleCancelWithConfirm = () => {
    Modal.confirm({
      title: "Xác nhận từ chối",
      content: "Anh/chị có chắc chắn muốn từ chối này?",
      okText: "Xác nhận",
      cancelText: "Bỏ qua",
      onOk: () => cancelRequest(),
    });
  };

  const cancelRequest = () => {
    const { fields } = officialBusinessTicketRequest;
    // fields.eRequestStatus = requestStatus.rejected;
    const dateReject = getUCTDate();

    if (!comment) {
      setNotificationTitle("Thông báo");
      setNotificationMessage("Anh Chị vui lòng nhập lưu ý khi hủy phiếu vào ô phía trên !");
      setIsNotificationModalOpen(true);
      return;
    }
    const rejectComment = {
      type: "reject",
      value: comment,
      date: `${getDDMMYYYFormat(dateReject)} ${getHHmmFormat(dateReject)}`,
    };
    switch (approvalType) {
      case approverType.approver:
        const arrComment = fields.eDeptHeadComment ? JSON.parse(fields.eDeptHeadComment) : [];
        const approverComment = [...arrComment];
        approverComment.push(rejectComment);
        fields.eApprovedStatus = requestStatus.rejected;
        fields.eApprovedDate = dateReject;
        fields.eDeptHeadComment = JSON.stringify(approverComment);
        fields.eRequestStatus = requestStatus.rejected;
        break;
      case approverType.itlead:
        const arrCommentITLead = fields.eITLeadComment ? JSON.parse(fields.eITLeadComment) : [];
        const approverCommentITLead = [...arrCommentITLead];
        approverCommentITLead.push(rejectComment);
        fields.eITLeadComment = JSON.stringify(approverCommentITLead);
        fields.eApprovedByITLeadStatus = requestStatus.rejected;
        fields.eApprovedByITLeadDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      case approverType.ithead:
        const arrCommentITHead = fields.eITHeadComment ? JSON.parse(fields.eITHeadComment) : [];
        const approverCommentITHead = [...arrCommentITHead];
        approverCommentITHead.push(rejectComment);
        fields.eITHeadComment = JSON.stringify(approverCommentITHead);
        fields.eApprovedByITHeadStatus = requestStatus.rejected;
        fields.eApprovedByITHeadDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      case approverType.assignee:
        const arrCommentAssigned = fields.eAssigneeComment ? JSON.parse(fields.eAssigneeComment) : [];
        const approverCommentAssigned = [...arrCommentAssigned];
        approverCommentAssigned.push(rejectComment);
        fields.eAssigneeComment = JSON.stringify(approverCommentAssigned);
        fields.eAssigneeStatus = requestStatus.rejected;
        fields.eAssigneeStatusDate = dateReject;
        fields.eRequestStatus = requestStatus.rejected;
        break;
      default:
        break;
    }

    // Cập nhật trạng thái trong eSteps
    if (hrProfile && fields.eSteps) {
      try {
        const currentUserEmail = hrProfile.Email?.toLowerCase() || userData?.email?.toLowerCase();

        if (currentUserEmail) {
          const steps = JSON.parse(fields.eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;

          if (steps && steps.length > 0) {
            // Tìm step hiện tại và approver hiện tại
            let found = false;
            for (let stepIndex = 0; stepIndex < steps.length; stepIndex++) {
              const step = steps[stepIndex];
              const isStepCompleted = step.every((approver) => approver.isApproved || approver.isRejected);

              if (!isStepCompleted) {
                for (const approver of step) {
                  const approverEmail = approver.email?.toLowerCase();
                  if (approverEmail === currentUserEmail && !approver.isApproved && !approver.isRejected) {
                    // Cập nhật approver: đánh dấu đã reject và thêm history
                    approver.isApproved = false;
                    approver.isRejected = true;
                    approver.histories = approver.histories || [];
                    approver.histories.push({
                      label: "Đã từ chối",
                      status: "rejected",
                      updatedDateTime: dateReject,
                      reason: comment || "",
                    });
                    found = true;
                    break;
                  }
                }
                if (found) {
                  break;
                }
              }
            }

            // Cập nhật lại eSteps trong fields
            if (found) {
              fields.eSteps = JSON.stringify(steps);
              fields.eRequestStatus = requestStatus.rejected;
            }
          }
        }
      } catch (error) {
        console.error("Error updating eSteps:", error);
      }
    }

    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then((res) => {
        CreateNotification({
          title: "Thành công",
          body: `Từ chối thành công.`,
          icon: "/icons/success.png",
        });
        queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
        sendMail(requestStatus.rejected, rejectComment);
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch((err) => {
        CreateNotification({
          title: "Thất bại",
          body: `Từ chối thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const checkApproverType = () => {
    const {
      eApprovedBy,
      eApprovedByITLead,
      eApprovedByITHead,
      eAssignee,
      eApprovedStatus,
      eApprovedByITLeadStatus,
      eApprovedByITHeadStatus,
      eAssigneeStatus,
    } = officialBusinessTicketRequest.fields;
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[0] : "";
    const approvedByITLeadEmail = eApprovedByITLead ? eApprovedByITLead.split("|")[0] : "";
    const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split("|")[0] : "";
    const assigneeEmail = eAssignee ? eAssignee.split("|")[0] : "";
    if (currentUserName.toLowerCase() === approverEmail.toLowerCase() && !eApprovedStatus) {
      setApprovalType(approverType.approver);
    } else if (currentUserName.toLowerCase() === approvedByITLeadEmail.toLowerCase() && !eApprovedByITLeadStatus) {
      setApprovalType(approverType.itlead);
    } else if (currentUserName.toLowerCase() === approvedByITHeadEmail.toLowerCase() && !eApprovedByITHeadStatus) {
      setApprovalType(approverType.ithead);
    } else if (currentUserName.toLowerCase() === assigneeEmail.toLowerCase() && !eAssigneeStatus) {
      setApprovalType(approverType.assignee);
    }
  };

  const checkApproverStep = () => {
    const { eApprovedStatus, eApprovedByITLeadStatus, eApprovedByITHeadStatus, eAssigneeStatus } =
      officialBusinessTicketRequest.fields;
    if (!eApprovedStatus) {
      setApprovalStep(approverType.approver);
    } else if (!eApprovedByITLeadStatus) {
      setApprovalStep(approverType.itlead);
    } else if (!eApprovedByITHeadStatus) {
      setApprovalStep(approverType.ithead);
    } else if (!eAssigneeStatus) {
      setApprovalStep(approverType.assignee);
    }
  };

  const checkEdit = () => {
    if (!officialBusinessTicketRequest) {
      return false;
    }

    const { eSteps } = officialBusinessTicketRequest.fields;
    if (!eSteps) {
      // Nếu không có eSteps, fallback về logic cũ
      return (
        !officialBusinessTicketRequest.fields.eApprovedByITLeadStatus &&
        !officialBusinessTicketRequest.fields.eApprovedByITHeadStatus &&
        !officialBusinessTicketRequest.fields.eAssigneeStatus
      );
    }

    try {
      const steps = JSON.parse(eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;

      if (!steps || steps.length === 0) {
        return false;
      }

      // Bỏ qua bước "Khởi tạo" (thường là step đầu tiên)
      const approvalSteps = steps.filter((step, index) => {
        // Bỏ qua step đầu tiên nếu title là "Khởi tạo"
        if (index === 0 && step[0]?.title === "Khởi tạo") {
          return false;
        }
        return true;
      });

      // Kiểm tra xem tất cả các steps (trừ bước Khởi tạo) đều chưa có người duyệt
      const hasNoApprover = approvalSteps.every((step) => {
        return step.every((approver) => !approver.isApproved && !approver.isRejected);
      });

      return hasNoApprover;
    } catch (error) {
      console.error("Error parsing eSteps in checkEdit:", error);
      // Fallback về logic cũ nếu có lỗi
      return (
        !officialBusinessTicketRequest.fields.eApprovedByITLeadStatus &&
        !officialBusinessTicketRequest.fields.eApprovedByITHeadStatus &&
        !officialBusinessTicketRequest.fields.eAssigneeStatus
      );
    }
  };

  const checkApproval = () => {
    if (!officialBusinessTicketRequest || !hrProfile) {
      return false;
    }

    const { eSteps } = officialBusinessTicketRequest?.fields;
    const steps = JSON.parse(eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;

    if (!steps || steps.length === 0) {
      return false;
    }

    const currentUserEmail = hrProfile.Email?.toLowerCase() || userData?.email?.toLowerCase();

    if (!currentUserEmail) {
      return false;
    }

    // Duyệt theo thứ tự từ đầu đến cuối để tìm step hiện tại đang chờ phê duyệt
    for (let stepIndex = 0; stepIndex < steps.length; stepIndex++) {
      const step = steps[stepIndex];

      // Kiểm tra xem step này đã hoàn thành chưa (tất cả approvers đã approve hoặc có reject)
      const isStepCompleted = step.some((approver) => approver.isApproved || approver.isRejected);

      // Nếu step này chưa hoàn thành, đây là step hiện tại đang chờ phê duyệt
      if (!isStepCompleted) {
        // Kiểm tra xem có step nào trước đó đã bị reject chưa
        for (let prevStepIndex = 0; prevStepIndex < stepIndex; prevStepIndex++) {
          const prevStep = steps[prevStepIndex];
          const hasRejected = prevStep.some((approver) => approver.isRejected);
          if (hasRejected) {
            // Nếu có reject ở step trước, không được xử lý ở step này
            return false;
          }
        }

        // Kiểm tra xem user hiện tại có trong step này không
        for (const approver of step) {
          const approverEmail = approver.email?.toLowerCase();

          // Nếu user hiện tại là approver trong step này và chưa approve/reject
          if (approverEmail === currentUserEmail && !approver.isApproved && !approver.isRejected) {
            return true;
          }
        }
        // Nếu step này chưa hoàn thành nhưng user không có trong step này, return false
        // Vì phải duyệt theo thứ tự, không thể bỏ qua step

        return false;
      }
    }

    return false;
  };

  // const checkCanRecover = () => {
  //   if (!officialBusinessTicketRequest || !hrProfile) {
  //     return false;
  //   }

  //   const { eSteps } = officialBusinessTicketRequest?.fields;
  //   const steps = JSON.parse(eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;

  //   if (!steps || steps.length === 0) {
  //     return false;
  //   }

  //   const currentUserEmail = hrProfile.Email?.toLowerCase() || userData?.email?.toLowerCase();

  //   if (!currentUserEmail) {
  //     return false;
  //   }

  //   // Tìm step hiện tại đang chờ phê duyệt
  //   let currentStepIndex = -1;
  //   let currentStep: ApprovalProcessApprover[] | null = null;
  //   for (let stepIndex = 0; stepIndex < steps.length; stepIndex++) {
  //     const step = steps[stepIndex];
  //     // Kiểm tra xem step này chưa có người duyệt (tất cả approvers đều chưa approve và chưa reject)
  //     const hasNoApprover = step.every((approver) => !approver.isApproved && !approver.isRejected);
  //     if (hasNoApprover) {
  //       currentStepIndex = stepIndex;
  //       currentStep = step;
  //       break;
  //     }
  //   }

  //   // Nếu không có step nào đang chờ phê duyệt (tất cả đã có người duyệt), không thể thu hồi
  //   if (currentStepIndex === -1 || !currentStep) {
  //     return false;
  //   }

  //   // Kiểm tra điều kiện 1: Bước duyệt hiện tại chưa có người duyệt
  //   // (Đã kiểm tra ở trên với hasNoApprover)

  //   // Kiểm tra điều kiện 2: Người dùng hiện tại là người đã xử lý ở bước trước
  //   if (currentStepIndex === 0) {
  //     // Nếu là step đầu tiên, không có step trước đó, không thể thu hồi
  //     return false;
  //   }

  //   // Kiểm tra xem user đã approve ở step trước step hiện tại chưa
  //   for (let stepIndex = currentStepIndex - 1; stepIndex < currentStepIndex; stepIndex++) {
  //     const step = steps[stepIndex];

  //     if (stepIndex === 0 && step[0]?.title === "Khởi tạo") {
  //       continue;
  //     }

  //     for (const approver of step) {
  //       const approverEmail = approver.email?.toLowerCase();
  //       if (approverEmail === currentUserEmail && (approver.isApproved || approver.isRejected)) {
  //         // User đã approve ở step trước đó và step hiện tại chưa có người duyệt, có thể thu hồi
  //         return true;
  //       }
  //     }
  //   }

  //   return false;
  // };

  const handleRevoke = () => {
    if (!officialBusinessTicketRequest) return;

    const steps = JSON.parse(officialBusinessTicketRequest.fields.eSteps || "[]") as Array<
      Array<ApprovalProcessApprover>
    >;

    if (!steps.length) return;

    const firstStep = steps[0];

    if (!firstStep.length) return;

    const firstApprover = firstStep[0];

    firstApprover.histories.push({
      label: "Ngày thu hồi",
      reason: "",
      status: requestStatus.revoked,
      updatedDateTime: getUCTDate(),
    });

    const fields = {
      eRequestStatus: requestStatus.revoked,
      eSteps: JSON.stringify(steps),
    };
    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then(() => {
        CreateNotification({
          title: "Thành công",
          body: `Thu hồi thành công.`,
          icon: "/icons/success.png",
        });
        queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch(() => {
        CreateNotification({
          title: "Thất bại",
          body: `Thu hồi thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const handleRevokeWithConfirm = () => {
    Modal.confirm({
      title: "Xác nhận thu hồi",
      content: "Anh/chị có chắc chắn muốn thu hồi phiếu này?",
      okText: "Xác nhận",
      cancelText: "Bỏ qua",
      onOk: () => handleRevoke(),
    });
  };

  const handleCancel = () => {
    if (!officialBusinessTicketRequest) return;

    const steps = JSON.parse(officialBusinessTicketRequest.fields.eSteps || "[]") as Array<
      Array<ApprovalProcessApprover>
    >;

    if (!steps.length) return;

    const firstStep = steps[0];

    if (!firstStep.length) return;

    const firstApprover = firstStep[0];

    firstApprover.histories.push({
      label: "Ngày hủy bỏ",
      reason: "",
      status: requestStatus.canceled,
      updatedDateTime: getUCTDate(),
    });

    const fields = {
      eRequestStatus: requestStatus.canceled,
      eSteps: JSON.stringify(steps),
    };
    BusinessTicketRequestService.updateBusinessTicketRequest(officialBusinessTicketRequest.id, fields)
      .then(() => {
        CreateNotification({
          title: "Thành công",
          body: `Hủy phiếu thành công.`,
          icon: "/icons/success.png",
        });
        queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
        history.push(Routes.procedureCollaborateTicket.path);
      })
      .catch(() => {
        CreateNotification({
          title: "Thất bại",
          body: `Hủy phiếu thất bại.`,
          icon: "/icons/error.png",
        });
      });
  };

  const handleCancelTicketWithConfirm = () => {
    Modal.confirm({
      title: "Xác nhận hủy phiếu",
      content: "Anh/chị có chắc chắn muốn hủy phiếu này?",
      okText: "Xác nhận",
      cancelText: "Bỏ qua",
      onOk: () => handleCancel(),
    });
  };

  const handlePassportChange = (e: any) => {
    setPassport(e);
  };

  const onApproverChange = (selectedOptions: any) => {
    setPickedItHead(selectedOptions ? selectedOptions : "");
  };

  const getButtonText = () => {
    if (!officialBusinessTicketRequest || !hrProfile) {
      return "Đồng ý";
    }

    const { eSteps } = officialBusinessTicketRequest?.fields;
    const steps = JSON.parse(eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;

    if (!steps || steps.length === 0) {
      return "Đồng ý";
    }

    const currentUserEmail = hrProfile.Email?.toLowerCase() || userData?.email?.toLowerCase();

    if (!currentUserEmail) {
      return "Đồng ý";
    }

    // Tìm step hiện tại đang chờ phê duyệt
    let currentStepIndex = -1;
    for (let stepIndex = 0; stepIndex < steps.length; stepIndex++) {
      const step = steps[stepIndex];
      const isStepCompleted = step.every((approver) => approver.isApproved || approver.isRejected);

      if (!isStepCompleted) {
        // Kiểm tra xem user hiện tại có trong step này không
        for (const approver of step) {
          const approverEmail = approver.email?.toLowerCase();
          if (approverEmail === currentUserEmail && !approver.isApproved && !approver.isRejected) {
            currentStepIndex = stepIndex;
            break;
          }
        }
        if (currentStepIndex !== -1) {
          break;
        }
      }
    }

    // Nếu không tìm thấy step hiện tại, mặc định là "Đồng ý"
    if (currentStepIndex === -1) {
      return "Đồng ý";
    }

    // Kiểm tra xem step hiện tại có phải là step cuối cùng không
    // Step cuối cùng là step có index = steps.length - 1
    if (currentStepIndex === steps.length - 1) {
      return "Hoàn thành";
    }

    return "Đồng ý";
  };

  const getTicketType = (ticketType: string) => {
    return ticketType === "full"
      ? "Cấp vé và giấy đi đường"
      : ticketType === "ticket"
      ? "Chỉ cấp vé công tác"
      : ticketType === "refund"
      ? "Hoàn vé"
      : "Chỉ cấp giấy đi đường";
  };

  const handleUpdatePin = useCallback(
    async (isPin: boolean) => {
      try {
        if (!officialBusinessTicketRequest) return;
        const pins: any[] = officialBusinessTicketRequest.fields.ePins
          ? JSON.parse(officialBusinessTicketRequest.fields.ePins)
          : [];
        const index = pins.findIndex((pin: string) => pin === currentUserName?.toLowerCase());
        if (!isPin && index < 0) return;
        if (isPin && index > -1) return;
        if (!isPin && index > -1) pins.splice(index, 1);
        if (isPin && index < 0) pins.push(currentUserName?.toLowerCase());

        const fields = {
          ePins: JSON.stringify(pins),
        };

        await BusinessTicketRequestService.updateBusinessTicketRequest(id, fields);
        queryClient.invalidateQueries({ queryKey: ["business-tickets-requests"] });
      } catch (error) {
        console.log(error);
      }
    },
    [currentUserName, id, officialBusinessTicketRequest, queryClient],
  );

  const isPin = useCallback(() => {
    if (!officialBusinessTicketRequest) return false;
    const pins: any[] = officialBusinessTicketRequest.fields.ePins
      ? JSON.parse(officialBusinessTicketRequest.fields.ePins)
      : [];
    return pins.findIndex((pin: string) => pin === currentUserName?.toLowerCase()) >= 0;
  }, [currentUserName, officialBusinessTicketRequest]);

  const ctx = useMemo<ProcessContextType<any>>(
    () => ({
      Request: officialBusinessTicketRequest,
      updatePin: handleUpdatePin,
      isPin: isPin,
    }),
    [handleUpdatePin, isPin, officialBusinessTicketRequest],
  );

  const fetchComments = useCallback((id: any) => {
    BusinessTicketRequestService.getBusinessTicketRequest(id)
      .then((res) => {
        setOfficialBusinessTicketRequest(res);

        try {
          setFileContent(JSON.parse(res.fields.eFileContent));
        } catch (error) {
          setFileContent([]);
        }

        if (res.fields) {
          // setComment(res.fields.eApprovalComments);
          if (res?.fields?.ePassportContent) {
            setPassport(JSON.parse(res.fields.ePassportContent));
          } else {
            const travelTicket = res?.fields?.eContent ? JSON.parse(res.fields.eContent) : [];
            const newTravelTicket = travelTicket.map((e: any, index: number) => {
              const tripArray = _.cloneDeep(e.TripBusiness) || [];
              const modifiedTripArray = tripArray.map((obj: any) => ({ ...obj, to: "" }));
              return {
                id: index + 2,
                PassportForPerson: e.Name,
                Position: e.Position,
                Unit: res?.fields.eUnit || "",
                SendOnForBusiness: res?.fields.eOffice || "",
                BusinessTime:
                  getDDMMYYYFormat(new Date(res?.fields?.eWorkingTime)) +
                  " - " +
                  getDDMMYYYFormat(new Date(res?.fields?.eFinishTime)),
                TripBusiness: modifiedTripArray,
                Trip: e.TripBusiness,
                Class: e.Class || "",
                TickNumber: e.TickNumber || "",
                // BusinessUnit: res?.fields.eOffice || '',
                BusinessContent: res?.fields.eDescription || "",
                ConfirmBusinessUnit: "",
                ITHead: res?.fields?.eApprovedByITHead,
                eBaseOnDecision: res?.fields?.eBaseOnDecision,
                DepartmentScope: res?.fields?.DepartmentScope,
                eSteps: JSON.parse(res?.fields?.eSteps || "[]"),
              };
            });
            setPassport(newTravelTicket);
          }
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  const refreshCommnents = useCallback(() => {
    id && fetchComments(id);
  }, [fetchComments, id]);

  useEffect(() => {
    fetchComments(id);
  }, [fetchComments, id]);

  const handleGoBack = () => {
    if (history.action === "PUSH") history.goBack();
    else history.push(Routes.procedureCollaborateTicket.path);
  };

  useEffect(() => {
    if (officialBusinessTicketRequest) {
      checkApproverType();
      checkApproverStep();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officialBusinessTicketRequest]);

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={handleGoBack}>
            <Icon.ArrowLeft />
          </div>
          {"Xem Xét Duyệt"}
        </div>
      </div>

      {(() => {
        if (!officialBusinessTicketRequest) return <Message type="loading" />;
        if (officialBusinessTicketRequest.errorMessage)
          return <Message type="error" message={officialBusinessTicketRequest.errorMessage} />;

        const { fields } = officialBusinessTicketRequest;
        const {
          // eSoftwareId,
          // eStaff,
          // eReason,
          eContent,
          eApprovedByITLead,
          eBaseOnProposal,
          eTicketType,
          eSteps,
        } = fields;
        const contentData = JSON.parse(eContent);
        const eBaseOnProposalFileUrl = eBaseOnProposal ? JSON.parse(eBaseOnProposal) : [];
        return (
          <>
            <div className="col-lg-12 col-md-12">
              <div>
                <ProcessContextProvider context={ctx} isHideUI={true}>
                  <ApprovalProcess
                    title={
                      <span>
                        Quy trình duyệt - yêu cầu {officialBusinessTicketRequest.id} <PinLayout />
                      </span>
                    }
                    steps={JSON.parse(eSteps || "[]")}
                  />
                </ProcessContextProvider>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 mb-4">
              <Box
                title={
                  <span>
                    {isRefund ? "Thông tin hoàn vé công tác" : "Thông tin cấp vé công tác"}{" "}
                    {officialBusinessTicketRequest.fields.refundFor && (
                      <a
                        rel="noreferrer"
                        href={`/procedure/business-tickets/details/${officialBusinessTicketRequest.fields.refundFor}`}
                        target="_blank"
                        className="hover:underline"
                      >
                        (số phiếu cấp vé {officialBusinessTicketRequest.fields.refundFor})
                      </a>
                    )}
                  </span>
                }
                className="full-height box__detail-container"
              >
                <div className="TableInformation">
                  <Row gutter={[32, 0]}>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem textLeft="Nhu cầu" textRight={getTicketType(eTicketType)} />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Người yêu cầu:"
                        textRight={officialBusinessTicketRequest.createdBy.user.displayName}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="SĐT Người yêu cầu:"
                        textRight={officialBusinessTicketRequest.fields.ePhoneNumber}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Cơ quan/Đơn vị:"
                        textRight={officialBusinessTicketRequest.fields.eDepartment}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem textLeft="Đơn vị:" textRight={officialBusinessTicketRequest.fields.eUnit} />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Phạm vi cấp cho cơ quan/ đơn vị:"
                        textRight={(officialBusinessTicketRequest.fields.DepartmentScope || "")
                          .split("|")
                          .findLast((item: string) => item)}
                      />
                    </Col>
                    <Col span={12} xs={24} lg={12}>
                      <BoxSectionItem
                        textLeft="Căn cứ theo quyết định:"
                        textRight={officialBusinessTicketRequest.fields.eBaseOnDecision || ""}
                      />
                    </Col>
                    {eTicketType !== "refund" && (
                      <>
                        <Col span={12} xs={24} lg={12}>
                          <BoxSectionItem
                            textLeft="Thời gian bắt đầu: "
                            textRight={getDDMMYYYFormat(officialBusinessTicketRequest.fields.eWorkingTime)}
                          />
                        </Col>
                        <Col span={12} xs={24} lg={12}>
                          <BoxSectionItem
                            textLeft="Thời gian kết thúc: "
                            textRight={getDDMMYYYFormat(officialBusinessTicketRequest.fields.eFinishTime)}
                          />
                        </Col>
                        <Col span={12} xs={24} lg={12}>
                          <BoxSectionItem
                            textLeft="Hành trình:"
                            textRight={officialBusinessTicketRequest.fields.eTrip}
                          />
                        </Col>
                      </>
                    )}

                    <Col span={24} xs={24} lg={24}>
                      <div
                        style={{
                          paddingTop: 23,
                          paddingInline: 15,
                        }}
                      >
                        <Text>Căn cứ theo tờ trình:</Text>
                        <span>
                          <FileAttachmentCard listFile={eBaseOnProposalFileUrl}></FileAttachmentCard>
                        </span>
                      </div>
                    </Col>
                    <Col span={24} xs={24} lg={24}>
                      <div
                        style={{
                          paddingBlock: 23,
                          paddingInline: 15,
                        }}
                      >
                        <Text>Nội dung:</Text>
                        &nbsp;
                        <Text strong>{officialBusinessTicketRequest.fields.eDescription}</Text>
                      </div>
                    </Col>
                  </Row>
                  {(eTicketType === "refund" && <></>) || (
                    <table>
                      <tbody>
                        <td className="py-2 text-uppercase font-weight-bold">Chi tiết</td>
                        <tr>
                          <Row>
                            <td colSpan={4}>
                              <div className="detailTable">
                                <table className="table table-striped ">
                                  <thead>
                                    <tr>
                                      <th>Họ và tên</th>
                                      <th>Chức danh</th>
                                      <th>Hạng vé</th>
                                      <th>Số vé</th>
                                      <th>Hành trình</th>
                                      {/* <th>Chuyến bay đi / giờ / ngày</th>
                                  <th>Chuyến bay về / giờ / ngày</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {contentData.map((item: any, key: any) => {
                                      return (
                                        <tr key={key}>
                                          <td>{item.Name}</td>
                                          <td>{item.Position}</td>
                                          <td>{item.Class}</td>
                                          <td>{item.TickNumber}</td>
                                          <td>
                                            {item.TripBusiness.map((e: any) => (
                                              <div>{`${e.from} - ${e.to} (${getDDMMYYYFormat(e.date)} ${getHHmmFormat(
                                                e.date,
                                              )})`}</div>
                                            ))}
                                          </td>
                                          {/* <td>{item.FlightAway}</td>
                                      <td>{item.ReturnFlight}</td> */}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </Row>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <InputWraper
                              isRequired
                              inputProps={getInputProps("passport2")}
                              renderInput={(state) => (
                                <InputArrayData
                                  {...state}
                                  form={PassportContentForm}
                                  value={passport.length > 0 ? passport : null}
                                  onChange={handlePassportChange}
                                  isTrip={true}
                                  structure={PassportContentStructure}
                                  isDisabled={true}
                                  exportPassport={true}
                                  // isDisabled={approvalStep === approverType.itlead &&  eApprovedByITLead.split("|")[0] === currentUserName.toLowerCase() ? false : true}
                                  isDisableEdit={
                                    approvalStep === approverType.itlead &&
                                    eApprovedByITLead.split("|")[0] === currentUserName.toLowerCase()
                                      ? false
                                      : true
                                  }
                                />
                              )}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
                {approvalType === approverType.itlead && approvalStep === approvalType && (
                  <>
                    {/* {officialBusinessTicketRequest.fields.eDepartment !==
                        "Phòng Công nghệ thông tin" && (
                        <div className="InputWraper py-4">
                          <div className="mb-2">
                            Đơn vị quản lý chương trình
                          </div>
                          <div className="wraper">
                            <div className="people_picker-custom-detail">
                              <PeoplePicker
                                className="people-picker"
                                placeholder="Vui lòng chọn đơn vị quản lý chương trình"
                                type={PersonType.any}
                                // selectionChanged={onITHeadChange}
                              />
                            </div>
                          </div>
                        </div>
                      )} */}
                    <div className="InputWraper py-4">
                      <div className="mb-2">Bộ phận hành chính VPCT</div>
                      <div className="wraper">
                        <div className="people_picker-custom-detail">
                          <UserSelect
                            name="Chọn cán bộ VPCT"
                            onTouched={() => 1}
                            placeholder="Vui lòng chọn cán bộ VPCT"
                            options={eApprovalChangeOptions}
                            value={pickedItHead}
                            onChange={onApproverChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Box>
            </div>

            {eTicketType === "refund" && (
              <div className="col-lg-12 col-md-12 mb-4">
                <Box title="Thông tin yêu cầu hoàn vé" className="full-height box__detail-container">
                  <div>
                    <div className="-ml-2 mb-2">
                      <DownloadPassport value={passport} isRefund />
                    </div>
                    <div className="detailTable">
                      <table className="table table-striped ">
                        <thead>
                          <tr>
                            <th>Họ và tên</th>
                            <th>Chức danh</th>
                            <th>Hạng vé</th>
                            <th>Số vé</th>
                            <th>Hành trình</th>
                            {/* <th>Chuyến bay đi / giờ / ngày</th>
                                  <th>Chuyến bay về / giờ / ngày</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {contentData.map((item: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{item.Name}</td>
                                <td>{item.Position}</td>
                                <td>{item.Class}</td>
                                <td>{item.TickNumber}</td>
                                <td>
                                  {item.TripBusiness.map((e: any) => (
                                    <div>{`${e.from} - ${e.to} (${getDDMMYYYFormat(e.date)} ${getHHmmFormat(
                                      e.date,
                                    )})`}</div>
                                  ))}
                                </td>
                                {/* <td>{item.FlightAway}</td>
                                      <td>{item.ReturnFlight}</td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Box>
              </div>
            )}

            {fileContent.length > 0 && (
              <div className="col-lg-12 col-md-12 mb-4">
                <Box title="Tệp đính kèm" className="full-height box__detail-container">
                  <FileAttachmentCard listFile={fileContent} />
                </Box>
              </div>
            )}

            <div className="col-lg-12 col-md-12 mb-4">
              <Box title="Thông tin trao đổi" className="full-height box__detail-container">
                <div className="">
                  <CommentSection
                    comments={[]}
                    data={officialBusinessTicketRequest}
                    user={user}
                    id={7}
                    className="mb-4"
                    refetch={refreshCommnents}
                  />
                </div>
              </Box>
            </div>

            <div className="col-lg-12 col-md-12 mb-4">
              <Box title="Lịch sử phê duyệt" className="full-height box__detail-container">
                <div className="InputWraper">
                  <div className="wraper">
                    <>
                      {(() => {
                        try {
                          const steps = JSON.parse(eSteps || "[]") as Array<Array<ApprovalProcessApprover>>;
                          if (!steps || steps.length === 0) {
                            return null;
                          }

                          // Duyệt qua tất cả các steps và approvers để lấy histories
                          const allHistories: Array<{
                            title: string;
                            name: string;
                            history: ApprovalProcessHistory;
                          }> = [];

                          steps.forEach((step) => {
                            step.forEach((approver) => {
                              if (approver.histories && approver.histories.length > 0) {
                                approver.histories.forEach((history) => {
                                  allHistories.push({
                                    title: approver.title,
                                    name: approver.name,
                                    history,
                                  });
                                });
                              }
                            });
                          });

                          // Sắp xếp theo thời gian (mới nhất trước)
                          allHistories.sort((a, b) => {
                            const dateA = new Date(a.history.updatedDateTime).getTime();
                            const dateB = new Date(b.history.updatedDateTime).getTime();
                            return dateB - dateA;
                          });

                          return allHistories.map((item, index) => {
                            const { title, name, history } = item;
                            const historyDate = new Date(history.updatedDateTime);
                            const formattedDate = `${getDDMMYYYFormat(historyDate)} ${getHHmmFormat(historyDate)}`;
                            const isRejected = history.status === "rejected";

                            return (
                              <div key={index} className="py-2 pl-3">
                                <p>
                                  <span className="font-weight-bold">
                                    {title}, {name}
                                  </span>{" "}
                                  {isRejected ? (
                                    <>
                                      đã từ chối với lý do: {history.reason} ({formattedDate})
                                    </>
                                  ) : (
                                    <>
                                      {history.label.toLowerCase()}, lưu ý: {history.reason} ({formattedDate})
                                    </>
                                  )}
                                </p>
                              </div>
                            );
                          });
                        } catch (error) {
                          console.error("Error parsing eSteps:", error);
                          return null;
                        }
                      })()}
                      {checkApproval() && (
                        <div className="input">
                          <textarea
                            value={comment}
                            placeholder="Nhập lưu ý, lý do phê duyệt"
                            onChange={(e) => setComment(e.target.value)}
                          />
                        </div>
                      )}
                    </>
                  </div>
                </div>

                <Spin spinning={isLoadingHrProfile}>
                  <div className="d-flex justify-content-center p-3">
                    {!isMinePage && !isDraft && checkApproval() && (
                      <>
                        <Button
                          className="mr10"
                          buttonType="success"
                          label={getButtonText()}
                          onClick={handleApproveWithConfirm}
                        />
                        {/* <Button
                              buttonType="grey"
                              label="Không đồng ý"
                              onClick={handleRejectWithConfirm}
                              className="mr10"
                            /> */}
                        <Button
                          buttonType="danger"
                          label="Từ chối"
                          onClick={handleCancelWithConfirm}
                          className="mr10"
                        />
                      </>
                    )}

                    {isMinePage && isMine && isDraft ? (
                      checkEdit() && (
                        <Button
                          className="mr5"
                          buttonType="warning"
                          label="Chỉnh sửa"
                          onClick={() =>
                            history.push(
                              Routes.createProcedureCollaborateTicket.path.replace(
                                ":id",
                                officialBusinessTicketRequest.id,
                              ),
                            )
                          }
                        />
                      )
                    ) : (
                      <></>
                    )}

                    {isMinePage && isMine && !isDraft && !isFinished && (
                      <Button
                        className="mr5"
                        buttonType="danger-outline"
                        label="Thu hồi"
                        onClick={handleRevokeWithConfirm}
                      />
                    )}
                    {isMinePage && isMine && isDraft && !isFinished && (
                      <Button
                        className="mr5"
                        buttonType="danger-outline"
                        label="Hủy phiếu"
                        onClick={handleCancelTicketWithConfirm}
                      />
                    )}

                    {/* {!checkApproval() && checkCanRecover() && (
                      <div className="d-flex justify-content-center">
                        <Button buttonType="grey" label="Thu hồi" onClick={handleRecoverWithConfirm} />
                      </div>
                    )} */}
                  </div>
                </Spin>
              </Box>
            </div>
          </>
        );
      })()}
      <ModalNotification
        open={isNotificationModalOpen}
        type="warning"
        title={notificationTitle}
        message={notificationMessage}
        onCancel={() => setIsNotificationModalOpen(false)}
        onOk={() => setIsNotificationModalOpen(false)}
      />
    </div>
  );
});
